import { Model } from 'core/model';
import { protoTimestampToDate } from 'core/util/dateUtils';

/**
 * Represents a single NMS custom report (DeviceProfile Report proto).
 *
 * These models are backed by the `/api/ui/recon/customReports` REST handlers,
 * which normalize snake_case service payloads to camelCase JSON for the UI, so
 * fields map directly.
 */
export default class CustomReportModel extends Model {
  get urlRoot() {
    return '/api/ui/recon/customReports';
  }

  get sortValues() {
    return {
      createdAt: () => {
        const createdAt = this.get('createdAt');
        const timestamp =
          typeof createdAt === 'object' ? protoTimestampToDate(createdAt)?.getTime() : new Date(createdAt).getTime();

        return Number.isNaN(timestamp) ? 0 : (timestamp ?? 0);
      }
    };
  }

  serialize(data) {
    return { report: super.serialize(data) };
  }

  deserialize(data) {
    return super.deserialize(data?.report ?? data);
  }
}
